const isDev = process.env.NODE_ENV === 'development' && process.env.REACT_APP_FORCE_PROD !== 'true';

const TEST_APP_ID = '824396629989622';
const TEST_CONFIG_ID = '1516114799708249';

const PROD_APP_ID = '1931504787374356';
const PROD_CONFIG_ID = '901083322220657';

export const facebookLoginAppId = window.REACT_APP_FACEBOOK_APP_ID || '607402994957828';
export const facebookLoginScope = 'public_profile,email';
export const facebookBusinessLoginAppId = isDev ? TEST_APP_ID : PROD_APP_ID;
export const facebookBusinessLoginConfigId = isDev ? TEST_CONFIG_ID : PROD_CONFIG_ID;
